import { render } from "./PhoneView.vue?vue&type=template&id=5c3f5428"
import script from "./PhoneView.vue?vue&type=script&lang=js"
export * from "./PhoneView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__